import React, { useState } from 'react'
import PropTypes from 'prop-types'

import PrimaryButton from '@components/inputs/button/primaryButton'

import {
  CloseIcon,
  Container,
  ButtonArea,
  Title,
  DetailContainer,
  HideDetail,
  Detail,
  Bold,
} from './styles'
import { Subtitle } from '../styles'

import 'material-icons/iconfont/outlined.css'

import Modal from '..'

const SendMessageModal = ({
  title,
  subtitle,
  isOpen,
  setClose,
  detail
}) => {
  const [showDetails, setShowDetails] = useState(detail != null)
  return (
    <Modal isOpen={isOpen} style={{ width: '20%' }}>
      <Container>
        <CloseIcon className="material-icons-outlined" onClick={setClose}>
          close
        </CloseIcon>
        <Title style={{ marginBottom: 0 }}>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        {detail && (
          <DetailContainer>
            <HideDetail onClick={() => setShowDetails(!showDetails)}>
              <span
                style={{ fontSize: '15px' }}
                className="material-symbols-outlined"
              >
                expand_
                {showDetails ? 'less' : 'more'}
              </span>
              {showDetails ? 'Ocultar ' : 'Ver '}
              detalhes
            </HideDetail>
            {showDetails && (
              <Detail>
                <Bold>Detalhes:</Bold>
                {detail}
              </Detail>
            )}
          </DetailContainer>
        )}
        <ButtonArea>
          <PrimaryButton onClick={setClose}>Ok, entendi</PrimaryButton>
        </ButtonArea>
      </Container>
    </Modal>
  )
}

SendMessageModal.propTypes = {
  isOpen: PropTypes.bool,
  setClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  detail: PropTypes.string,
}

SendMessageModal.defaultProps = {
  isOpen: false,
  title: 'Continuar ?',
  subtitle: null,
  detail: null,
}

export default SendMessageModal
